import React from "react";
import {PhraseQuestionDefinition} from "../../../state/questions";
import {Phrase} from "../common/Phrase";
import {QuestionDisplayProps} from "../Question";
import {TriviaStatus} from "../../../state/state";
import Explanation from "../common/Explanation";

export default function PhraseDisplay({question, aggregateResponses, state}:QuestionDisplayProps) {
	const phraseQuestion = question as PhraseQuestionDefinition;

	return <div data-qa="phrase-display">
		<Phrase question={phraseQuestion}/>
		{state === TriviaStatus.QuestionDetails &&
		<Explanation question={question} aggregateResponses={aggregateResponses} showFastest={true}/>
		}
	</div>;
}